// AI进宝
import httpInstance, { bigNumberTransformResponse } from '@/jmHttp/index';
import { aiChat } from '@/jmHttp/interface';
import { post } from '@/apis/sse';
import { BRM_AL_URL_HOST } from '@/apis/host';

// 会话回答反馈
export const answerFeedback = async (data, config = {}) => {
  return await httpInstance.post(aiChat.answerFeedback, data, config);
};

// 会话列表
export const sessionList = async (data, config = {}) => {
  return await httpInstance.post(aiChat.sessionList, data, config);
};

// 推荐提问列表
export const recommendQuestion = async (data, config = {}) => {
  return await httpInstance.post(aiChat.recommendQuestion, data, config);
};

// 删除会话
export const deleteSession = async (data, config = {}) => {
  return await httpInstance.post(aiChat.deleteSession, data, config);
};

// 获取用户设置
export const getSetting = async (data, config = {}) => {
  return await httpInstance.post(aiChat.getSetting, data, config);
};

// 保存用户设置
export const saveSetting = async (data, config = {}) => {
  return await httpInstance.post(aiChat.saveSetting, data, config);
};

// 更新会话标题
export const updateTitle = async (data, config = {}) => {
  return await httpInstance.post(aiChat.updateTitle, data, config);
};

// 提问模板(Ai进宝+)
export const templateList = async (data, config = {}) => {
  return await httpInstance.post(aiChat.templateList, data, config);
};

// 多轮对话(流式接口)
export const getChatConversation = async (data, config = {}) => {
  return await post(`${BRM_AL_URL_HOST}/api/ai-chat/chat`, data, config);
};

// 回答重试(流式接口)
export const retryConversation = async (data, config = {}) => {
  return await post(`${BRM_AL_URL_HOST}/api/ai-chat/retry`, data, config);
};

// 会话恢复(流式接口)
export const resumeConversation = async (data, config = {}) => {
  return await post(`${BRM_AL_URL_HOST}/api/ai-chat/resume`, data, config);
};

// 聊天记录列表
export const getChatList = async (data, config = {}) => {
  return await httpInstance.post(aiChat.chatList, data, config);
};

// 会话详情
export const sessionDetail = async (data, config = {}) => {
  return await httpInstance.post(aiChat.sessionDetail, data, config);
};

// 会话详情
export const chatCancel = async (data, config = {}) => {
  return await httpInstance.post(aiChat.chatCancel, data, config);
};

// 获取模型列表
export const chatModels = async (data, config = {}) => {
  return await httpInstance.post(aiChat.chatModels, data, config);
};

// 获取模型费率
export const getModelTiers = async (data = {}, config = {}) => {
  return await httpInstance.get(aiChat.modelTiers, data, config);
};

// 获取模型列表
export const validChatRecord = async (data, config = {}) => {
  return await httpInstance.post(aiChat.validChatRecord, data, config);
};

// 上传附件到文档库
export const uploadDoc = async (data, config = {}) => {
  return await httpInstance.post(aiChat.uploadDoc, data, config);
};

// 获取上传文档的解析状态
export const getDocStatus = async (data, config = {}) => {
  return await httpInstance.post(aiChat.getDocStatus, data, config);
};

// 获取OSS签名
export const ossSignature = async (data, config = {}) => {
  return await httpInstance.post(aiChat.ossSignature, data, config);
};

// 保存研究计划步骤
export const modifyResearchPlan = async (data, config = {}) => {
  return await httpInstance.post(aiChat.modifyResearchPlan, data, config);
};

// 删除研究计划步骤
export const deleteResearchPlan = async (data, config = {}) => {
  return await httpInstance.post(aiChat.deleteResearchPlan, data, config);
};

// （纪要、研报）详情页配置信息
export const getSummaryReportConfig = async (data, config = {}) => {
  return await httpInstance.post(aiChat.getSummaryReportConfig, data, config);
};

// 获取AI进宝生成的要点
export const getAichatPoints = async (data, config = {}) => {
  return await httpInstance.post(aiChat.getAichatPoints, data, config);
};

// (纪要、研报)校验纪要、文档是否在rag库
export const checkDocChunk = async (data, config = {}) => {
  return await httpInstance.post(aiChat.checkDocChunk, data, config);
};

// (纪要、研报)纪要原文、文档讲解、内外资研报上传至rag
export const uploadDocChunk = async (data, config = {}) => {
  return await httpInstance.post(aiChat.uploadDocChunk, data, config);
};

//  (全局搜索)会话开启可见设置
export const enableVisible = async (data, config = {}) => {
  return await httpInstance.post(aiChat.enableVisible, data, config);
};

//MCP列表查询
export const mcpServerList = async (data, config = {}) => {
  return await httpInstance.post(aiChat.mcpServerList, data, config);
};

//MCP Server tool 列表查询
export const mcpServerToolList = async (data, config = {}) => {
  return await httpInstance.post(aiChat.mcpServerToolList, data, config);
};

/** 获取当前用户可用的最新 x-mcp-key */
export const getMcpServerCurrentKey = async (data = {}, config = {}) => {
  return await httpInstance.get(aiChat.mcpServerCurrentKey, data, config);
};

/** 获取分组卡片列表 */
export const getMcpServerServers = async (data = {}, config = {}) => {
  return await httpInstance.get(aiChat.mcpServerServers, data, config);
};

/** 获取指定分组工具列表 */
export const getMcpServerGroupTools = async (data, config = {}) => {
  return await httpInstance.get(aiChat.mcpServerGroupTools, data, config);
};

/** 获取指定分组复制配置连接信息 */
export const getMcpServerConnectionInfo = async (data, config = {}) => {
  return await httpInstance.get(aiChat.mcpServerConnectionInfo, data, config);
};

//MCP Server 申请合作
export const mcpServerApplyCooperation = async (data, config = {}) => {
  return await httpInstance.post(aiChat.mcpServerApplyCooperation, data, config);
};

// 获取行业列表接口
export const searchIndustryList = async (data, config = {}) => {
  return await httpInstance.post(aiChat.searchIndustryList, data, config);
};

//获取智能体分组
export const getAgentGroupList = async (data, config = {}) => {
  return await httpInstance.post(aiChat.getAgentGroupList, data, config);
};

// 新增会话分享
export const addSessionShare = async (data, config = {}) => {
  return await httpInstance.post(aiChat.addSessionShare, data, config);
};

// 分享的会话详情
export const getSessionShareDetail = async (data, config = {}) => {
  return await httpInstance.post(aiChat.getSessionShareDetail, data, config);
};

// 投研大脑列表
export const researchBrainList = async (data, config = {}) => {
  return await httpInstance.post(aiChat.researchBrainList, data, config);
};

// 投研大脑-安装思维
export const installThoughtChain = async (data, config = {}) => {
  return await httpInstance.post(aiChat.installThoughtChain, data, config);
};

// 投研大脑-删除思维
export const deleteThoughtChain = async (data, config = {}) => {
  return await httpInstance.post(aiChat.deleteThoughtChain, data, config);
};

// 投研大脑-思维详情
export const getThoughtChainDetail = async (data, config = {}) => {
  return await httpInstance.post(aiChat.getThoughtChainDetail, data, config);
};

// 投研大脑-提取思维
export const extractThoughtChain = async (data, config = {}) => {
  return await httpInstance.post(aiChat.extractThoughtChain, data, {
    ...config,
    timeout: 120000
  });
};

// 投研大脑-创建思维
export const createThoughtChain = async (data, config = {}) => {
  return await httpInstance.post(aiChat.createThoughtChain, data, config);
};

// 投研大脑-更新思维
export const updateThoughtChain = async (data, config = {}) => {
  return await httpInstance.post(aiChat.updateThoughtChain, data, config);
};

// 投研大脑-批量上传文档
export const batchUploadDoc = async (data, config = {}) => {
  return await httpInstance.post(aiChat.batchUploadDoc, data, config);
};

// 投研大脑-获取思维链关联文档
export const getThoughtChainDocs = async (data, config = {}) => {
  return await httpInstance.post(aiChat.getThoughtChainDocs, data, {
    ...config,
    transformResponse: bigNumberTransformResponse
  });
};

// 投研大脑-删除思维链关联文档
export const batchDeleteDoc = async (data, config = {}) => {
  return await httpInstance.post(aiChat.batchDeleteDoc, data, config);
};

// MCP图表json修复
export const jsonRepair = async (data, config = {}) => {
  return await httpInstance.post(aiChat.jsonRepair, data, config);
};

// 校验是否能启用/禁用思维
export const checkEnableStatus = async (data, config = {}) => {
  return await httpInstance.post(aiChat.checkEnableStatus, data, config);
};

// 投研大脑开关
export const switchResearchBrain = async (data, config = {}) => {
  return await httpInstance.post(aiChat.switchResearchBrain, data, config);
};

// 获取思维链提取结果
export const queryThoughtExtractResult = async (data, config = {}) => {
  return await httpInstance.post(aiChat.queryThoughtExtractResult, data, config);
};

// 根据优化建议优化思维链
export const optimizeThoughtChainByAdvice = async (data, config = {}) => {
  return await httpInstance.post(aiChat.optimizeThoughtChainByAdvice, data, config);
};

// 思维优化获取结果
export const queryOptimizeThoughtChainResult = async (data, config = {}) => {
  return await httpInstance.post(aiChat.queryOptimizeThoughtChainResult, data, config);
};

// 获取思维评分结果
export const queryThoughtScoreResult = async (data, config = {}) => {
  return await httpInstance.post(aiChat.queryThoughtScoreResult, data, config);
};

// 润色思维
export const polishThoughtChain = async (data, config = {}) => {
  return await httpInstance.post(aiChat.polishThoughtChain, data, config);
};

// 思维润色获取结果
export const queryThoughtPolishResult = async (data, config = {}) => {
  return await httpInstance.post(aiChat.queryThoughtPolishResult, data, config);
};

// 标签：创建
export const createTag = async (data, config = {}) => {
  return await httpInstance.post(aiChat.tagCreate, data, config);
};

// 标签：删除
export const deleteTag = async (data, config = {}) => {
  return await httpInstance.post(aiChat.tagDelete, data, config);
};

// 标签列表（分页）
export const tagList = async (data, config = {}) => {
  return await httpInstance.post(aiChat.tagList, data, config);
};

// 全部标签列表（不分页）
export const tagAll = async (data, config = {}) => {
  return await httpInstance.post(aiChat.tagAll, data, config);
};

// 搜索标签
export const tagSearch = async (data, config = {}) => {
  return await httpInstance.post(aiChat.tagSearch, data, config);
};

// 会话标签绑定
export const sessionTagBind = async (data, config = {}) => {
  return await httpInstance.post(aiChat.sessionTagBind, data, config);
};

// 会话标签解绑
export const sessionTagUnbind = async (data, config = {}) => {
  return await httpInstance.post(aiChat.sessionTagUnbind, data, config);
};

// 会话标签列表
export const sessionTagList = async (data, config = {}) => {
  return await httpInstance.post(aiChat.sessionTagList, data, config);
};

// 更新标签
export const tagUpdate = async (data, config = {}) => {
  return await httpInstance.post(aiChat.tagUpdate, data, config);
};

// 标签置顶取反：仅传 tagId，后端根据当前状态自动切换
export const tagPin = async (data, config = {}) => {
  return await httpInstance.post(aiChat.tagPin, data, config);
};

// 查询当前用户内置渠道配置（聚合）：左侧 Tab 列表 + 各 Tab 下的配置 Map
export const getThirdChannelConfigList = async (data = {}, config = {}) => {
  return await httpInstance.post(aiChat.thirdChannelConfigList, data, config);
};

// 保存用户内置渠道配置（聊天 / 研究模式共用，通过 channelType 区分；任务模式走 openClawApi）
export const updateThirdChannelConfig = async (data = {}, config = {}) => {
  return await httpInstance.post(aiChat.thirdChannelConfigUpdate, data, config);
};

// 用户定时任务-新增（聊天 / 研究模式）
export const addUserSchedulerTask = async (data = {}, config = {}) => {
  return await httpInstance.post(aiChat.userSchedulerTaskAdd, data, config);
};

// 用户定时任务-列表（聊天 / 研究模式）
export const getUserSchedulerTaskList = async (data = {}, config = {}) => {
  return await httpInstance.post(aiChat.userSchedulerTaskList, data, config);
};

// 用户定时任务-模板列表
export const getUserSchedulerTaskTemplates = async (data = {}, config = {}) => {
  return await httpInstance.post(aiChat.userSchedulerTaskTemplates, data, config);
};

// 用户定时任务-模板详情（入参：{ templateKey }）
export const getUserSchedulerTaskTemplateDetail = async (data = {}, config = {}) => {
  return await httpInstance.post(aiChat.userSchedulerTaskTemplateDetail, data, config);
};

// 用户定时任务-删除（聊天 / 研究模式）
export const deleteUserSchedulerTask = async (data = {}, config = {}) => {
  return await httpInstance.post(aiChat.userSchedulerTaskDelete, data, config);
};

// 用户定时任务-切换启用/暂停（聊天 / 研究模式）
export const toggleUserSchedulerTask = async (data = {}, config = {}) => {
  return await httpInstance.post(aiChat.userSchedulerTaskToggle, data, config);
};

// 用户定时任务-更新（聊天 / 研究模式）
export const updateUserSchedulerTask = async (data = {}, config = {}) => {
  return await httpInstance.post(aiChat.userSchedulerTaskUpdate, data, config);
};

/**
 * 用户定时任务-立即执行（聊天 / 研究模式）
 * 入参：{ id }（定时任务 id，非用户 id）
 * 返回：{ taskId, xxlJobId, accepted, message }，accepted 仅表示调度中心接受了本次触发，
 * 不代表任务已执行成功；执行结果需通过列表接口的 lastExecStatus 读取
 * @param {{ id: number|string }} data
 * @param {object} [config]
 * @returns {Promise<object>}
 */
export const triggerUserSchedulerTaskNow = async (data = {}, config = {}) => {
  return await httpInstance.post(aiChat.userSchedulerTaskTriggerNow, data, config);
};

// 用户定时任务-通知渠道选项（聊天 / 研究模式）
// 入参：{ taskType: 'CHAT_MODE_TASK' | 'RESEARCH_MODE_TASK', agentId?, previewSize? }
// 返回：{ taskType, modeCode, channels: [{ channelType, channelKey, channelName, channelMode,
//   credentialConfigured, credentialEnabled, connected, available, configId,
//   contactsPreview: { list: [{ openId, nickname, avatar, lastMsgAt }], total, page, size },
//   conversationsPreview: { list: [{ chatId, chatName, chatType, parentId }], total, page, size }
// }] }
export const getUserSchedulerNotifyChannels = async (data = {}, config = {}) => {
  return await httpInstance.post(aiChat.userSchedulerTaskNotifyChannels, data, config);
};

// 第三方渠道扫码授权 - 获取二维码（base64 图片 + 轮询 token）
export const fetchThirdChannelQrcode = async (data = {}, config = {}) => {
  return await httpInstance.post(aiChat.thirdChannelQrcodeFetch, data, config);
};

// 第三方渠道扫码授权 - 轮询扫码状态（waiting / success / confirmed / expired）
export const getThirdChannelQrcodeStatus = async (data = {}, config = {}) => {
  return await httpInstance.post(aiChat.thirdChannelQrcodeStatus, data, config);
};

// AI 进宝-工具与连接-数据库：新增 MCP 配置
// 字段与任务模式 /api/copaw/mcp 的 client 子对象保持一致：
//   { name, transport, url?, headers?, command?, args?, env?, cwd?, remark?, agentIds? }
// 其中 stdio 模式用 command / args / env / cwd，streamable_http / sse 模式用 url
export const createAiAssistantMcpConfig = async (data = {}, config = {}) => {
  return await httpInstance.post(aiChat.aiAssistantCreateMcpConfig, data, config);
};

// AI 进宝-工具与连接-数据库：更新 MCP 配置
// 入参与 create 一致，额外必填 id（与 list-agent-mcp 返回项 mcpServerId 对应）
export const updateAiAssistantMcpConfig = async (data = {}, config = {}) => {
  return await httpInstance.put(aiChat.aiAssistantUpdateMcpConfig, data, config);
};

// AI 进宝-工具与连接-数据库：MCP 配置列表
// 返回 data[]：{ id, name, transport, represent, url, type, serviceKey }
// 其中 type=2 为平台官方，type=4 为当前登录用户自己创建
export const listAiAssistantMcpConfig = async (data = {}, config = {}) => {
  return await httpInstance.get(aiChat.aiAssistantListMcpConfig, data, config);
};

// AI 进宝-工具与连接-数据库：查询当前 agent 已启用的 MCP 列表
// Query：{ agentId }，如 research / chat / task
// 返回 data[]：{ bindingId, mcpServerId, name, represent, enabled, enableTools, disableTools, ... }
export const listAiAssistantAgentMcp = async (data = {}, config = {}) => {
  return await httpInstance.get(aiChat.aiAssistantListAgentMcp, data, config);
};

// AI 进宝-研究模式-工具与连接：官网官方 MCP 连接器列表
// 无请求参数；返回 data[]：{ mcpServerId, bindingId, name, desc, iconUrl, enabled, transport, url, command, args, env, cwd }
export const listAiAssistantOfficialConnector = async (data = {}, config = {}) => {
  return await httpInstance.get(aiChat.aiAssistantListOfficialConnector, data, config);
};

// AI 进宝-研究模式-工具与连接：切换官网官方 MCP 连接器状态
// 入参：{ mcpServerId, enabled: boolean }；返回 data：{ mcpServerId, bindingId, enabled }
export const toggleAiAssistantOfficialConnector = async (data = {}, config = {}) => {
  return await httpInstance.post(aiChat.aiAssistantToggleOfficialConnector, data, config);
};

// AI 进宝-工具与连接-数据库：MCP 绑定关系
// action=bind：{ mcpServerId, targets }；action=update：{ bindingId, enabled?, enableTools?, disableTools? }；action=delete：{ bindingId }
export const postAiAssistantMcpBinding = async (data = {}, config = {}) => {
  return await httpInstance.post(aiChat.aiAssistantMcpBinding, data, config);
};

// AI 进宝-工具与连接-数据库：探测指定 MCP 的工具列表
// 入参：{ mcpServerId }；返回 data[] 或 data.tools
export const probeAiAssistantMcp = async (data = {}, config = {}) => {
  return await httpInstance.post(aiChat.aiAssistantProbeMcp, data, config);
};

// AI 进宝-工具与连接-数据库-推荐连接器：连接器市场列表
// Query：{ status? } —— 'ALL' | 'CONNECTED' | 'PENDING'，默认 ALL
// 返回 data[]：{ connectorId, connectorKey, name, logoUrl, desc, description, docUrl, connectType, connectionStatus, mcpServerId, enabled, useCases }
// 注：desc 为卡片摘要文案；description 实际是文档/引导链接，非文本描述；docUrl 为详情弹窗「使用说明」外链，可能为空
export const listAiAssistantMarketConnector = async (data = {}, config = {}) => {
  return await httpInstance.get(aiChat.aiAssistantListMarketConnector, data, config);
};

// AI 进宝-工具与连接-数据库-推荐连接器：发起 OAuth 授权连接（仅 connectType=OAUTH 的连接器可调用）
// 入参：{ connectorId: integer }
// 返回 data：{ authUrl, connectionId } —— authUrl 用于跳转第三方授权页，connectionId 用于接口 4 轮询连接状态
export const startOauthConnectAiAssistantMarketConnector = async (data = {}, config = {}) => {
  return await httpInstance.post(aiChat.aiAssistantStartOauthConnect, data, config);
};

// AI 进宝-工具与连接-数据库-推荐连接器：查询 OAuth 连接状态（建议授权跳转后每 2s 轮询一次）
// 入参：{ connectionId: integer } —— 接口 3 返回的 connectionId
// 返回 data：{ status, errorMsg, mcpServerId } —— status 为 CONNECTED/ERROR/REAUTH_REQUIRED 时停止轮询；
// errorMsg 仅 ERROR/REAUTH_REQUIRED 时有值；mcpServerId 仅 CONNECTED 时有值
export const getAiAssistantConnectionStatus = async (data = {}, config = {}) => {
  return await httpInstance.get(aiChat.aiAssistantGetConnectionStatus, data, config);
};

// AI 进宝-工具与连接-数据库-推荐连接器：凭证型连接（仅 connectType=CREDENTIAL 的连接器可调用）
// 入参：{ connectorId: integer, credentials: { apiKey } | { email, authCode, host, port } }
// 返回 data：{ status, errorMsg, mcpServerId } —— 同步返回最终结果（内部含 MCP 探测），无需轮询
export const connectByCredentialAiAssistantMarketConnector = async (data = {}, config = {}) => {
  return await httpInstance.post(aiChat.aiAssistantConnectByCredential, data, config);
};

// AI 进宝-工具与连接-数据库-推荐连接器：断开连接（重置为 PENDING，关联 MCP Server 软删除，Agent 绑定解除）
// 入参：{ connectorId: integer }
// 返回 data：null
export const cancelAiAssistantMarketConnector = async (data = {}, config = {}) => {
  return await httpInstance.post(aiChat.aiAssistantCancelConnector, data, config);
};

// AI 进宝-工具与连接-数据库：删除 MCP 配置
// 入参：{ id }，与 list-agent-mcp 返回项的 mcpServerId 字段对应
// 备注：与 BRM 同类删除接口（json_xxx_delete-xxx）一致，统一走 act 路由的 POST 通道（后端确认改用 POST）
export const deleteAiAssistantMcpConfig = async (data = {}, config = {}) => {
  return await httpInstance.post(aiChat.aiAssistantDeleteMcpConfig, data, config);
};

// AI 进宝-工具与连接-技能：通过编写技能创建 workspace skill
// 入参：{ mode, agentId, name, content, tags?, channels?, config?, enabled? }
export const createAiAssistantSkillWorkspace = async (data = {}, config = {}) => {
  return await httpInstance.post(aiChat.aiAssistantCreateSkillWorkspace, data, config);
};

// AI 进宝-工具与连接-技能：workspace skill 列表
// Query：{ agentId }，如 research
// 响应：列表项新增 skillPoolId；列表中可能出现虚拟 builtin 条目（workspaceSkillId=null，仅有 skillPoolId）
export const listAiAssistantSkillWorkspace = async (data = {}, config = {}) => {
  return await httpInstance.get(aiChat.aiAssistantListSkillWorkspace, data, config);
};

// AI 进宝-工具与连接-技能：workspace skill 详情
// Query：{ workspaceSkillId?, skillPoolId? } —— 二选一；builtin 虚拟条目仅可用 skillPoolId
// 响应：新增 skillPoolId；券商技能 useCondition.userAuth 为 { passed, message? }
export const getAiAssistantSkillWorkspaceDetail = async (data = {}, config = {}) => {
  return await httpInstance.get(aiChat.aiAssistantGetSkillWorkspaceDetail, data, config);
};

// AI 进宝-工具与连接-技能：更新 workspace skill
// 入参：{ workspaceSkillId?, skillPoolId?, name?, tags?, content?, enabled?, channels?, config? }
// workspaceSkillId 与 skillPoolId 二选一；builtin 条目仅允许修改 enabled / tags / channels / config
export const saveAiAssistantSkillWorkspace = async (data = {}, config = {}) => {
  return await httpInstance.post(aiChat.aiAssistantSaveSkillWorkspace, data, config);
};

// AI 进宝-工具与连接-技能：删除 workspace skill
// 入参：{ workspaceSkillId }
export const deleteAiAssistantSkillWorkspace = async (data = {}, config = {}) => {
  return await httpInstance.post(aiChat.aiAssistantDeleteSkillWorkspace, data, config);
};

// AI 进宝-工具与连接-技能：通过文件（OSS ZIP）导入 workspace skill
// 入参：{ mode, agentId, ossUrl, sourceType, md5?, enabled? }
export const importAiAssistantWorkspaceSkill = async (data = {}, config = {}) => {
  return await httpInstance.post(aiChat.aiAssistantImportWorkspaceSkill, data, config);
};

// AI 进宝-工具与连接-技能：获取用户自建 workspace skill 技能包的下载信息
// 入参：{ workspaceSkillId }
// 响应：{ downloadUrl, fileName }，技能包存放在 OSS 上，由浏览器直接跳转下载
export const exportAiAssistantWorkspaceSkill = async (data = {}, config = {}) => {
  return await httpInstance.post(aiChat.aiAssistantExportWorkspaceSkill, data, config);
};

// 券商研究所技能-使用条件校验：一次性返回白名单、MCP 依赖、免责声明三项结论
// 入参：{ skillPoolId }
// 响应 data：{ userAuth: { passed, message? },
//             mcp: { passed, message?, mcpServers?: [{ mcpServerId, name, description?, iconUrl, status }] },
//             disclaimer: { passed, content? } }
export const checkAiAssistantBrokerSkillCondition = async (data = {}, config = {}) => {
  return await httpInstance.post(aiChat.aiAssistantCheckBrokerSkillCondition, data, config);
};

// 券商研究所技能-使用条件校验：确认当前版本免责声明
// 入参：{ skillPoolId }，响应 data：{ success }
export const confirmAiAssistantBrokerSkillDisclaimer = async (data = {}, config = {}) => {
  return await httpInstance.post(aiChat.aiAssistantConfirmBrokerSkillDisclaimer, data, config);
};
